<template>
  <input class="search-input-sml" type="text" name="search" autocomplete="off" :placeholder="placeholder" v-model="searchQuery">
</template>

<script>
import { mapState, mapGetters } from "vuex";
import debounce from 'lodash.debounce';

export default {
  props: ["placeholder"],
  data() {
    return {
      searchQuery: undefined
    }
  },
  computed: {
    ...mapGetters(["areaUrlCode"])
  },
  watch: {
    searchQuery() {
      this.debouncedSearchQueryCommit();
    }
  },
  created() {
    this.searchQuery = this.$store.getters.searchQuery;
    const debouncedSearchQueryCommit = this.debouncedSearchQueryCommit;
    this.debouncedSearchQueryCommit = debounce(debouncedSearchQueryCommit, 300);
  },
  methods: {
    debouncedSearchQueryCommit() {
      const areaUrlCode = this.areaUrlCode;
      const searchQuery = this.searchQuery || undefined;
      if (areaUrlCode) {
        this.$router.replace({
          name: 'publicationsWithArea',
          params: {areaUrlCode, page: undefined},
          query: {searchQuery}
        });
      }
      else {
        this.$router.replace({
          name: 'publications',
          params: {page: undefined},
          query: {searchQuery}
        });
      }

      if (this.searchQuery != '' && this.searchQuery != undefined) {
        ga('send', 'event', 'publications', 'search', this.searchQuery);
      }
    }
  }
};
</script>
